import { ReactFC } from 'src/types';
import { PurchaseDone } from '../../';

export const OnboardingSubscriptionActivated: ReactFC = () => {
  return <PurchaseDone />;
};
